<template>
    <a-card :bordered="false" :loading="pageLoading" v-if="pageLoading">
      Loading
    </a-card>
    <div v-else>
      <div
        :class="getScreen ? 'm-page-wrapper' : 'd-page-wrapper'"
        v-if="pageLoading === false"
      >
        <a-row :gutter="8">
          <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
            <a-card :loading="pageLoading" class="margin-bottom">
              <div slot="title">
                Credit Card Claim Ticket Manifest
                <small class="m-display-block m-text-small">{{
                  data.header.no_transaksi
                }}</small>
              </div>
              <a-popover slot="extra" trigger="click" placement="bottom">
                <span slot="title">Select Action</span>
                <ul class="m-list-wrapper bordered" slot="content">
                  <li>
                    <a-button
                      @click="handlePrint"
                      type="dashed"
                      icon="printer"
                      block
                      class="m-display-block"
                      :loading="printLoad.manifest"
                      >Claim CC Tiket Report</a-button
                    >
                  </li>
                  <li v-if="getAuth.username == data.user_pembuat.tlc">
                    <a-button-group>
                      <a-button
                        :disabled="
                          !(
                            data.last_status == 'Revised' &&
                            getAuth.username == data.user_pembuat.tlc
                          )
                        "
                        type="dashed"
                        icon="edit"
                        @click="handleEdit"
                        >Edit</a-button
                      >
                      <a-button
                        @click="handlecanceltrans"
                        :disabled="
                          !(
                            data.last_status == 'Revised' &&
                            getAuth.username == data.user_pembuat.tlc
                          )
                        "
                        type="danger"
                        icon="close-square"
                        :loading="printLoad.cancel"
                        >Cancel</a-button
                      >
                    </a-button-group>
                  </li>
                </ul>
                <a-button icon="more">Action</a-button>
              </a-popover>
  
              <div class="m-card-body">
                <ul class="m-list-wrapper bordered">
                  <li>
                    <span class="m-list-title" for>Created Date</span>
                    <span class="m-list-desc">{{
                      moment(data.header.tanggal_buat).format(
                        getDefaultDateFormat
                      )
                    }}</span>
                  </li>
                  <li>
                    <span class="m-list-title" for>User Creator</span>
                    <span class="m-list-desc">{{
                      data.header.user_pelapor
                    }}</span>
                  </li>
                  <li>
                    <span class="m-list-title" for>User CC</span>
                    <span class="m-list-desc">{{
                      data.header.user_cc?data.header.user_cc: '-'
                    }}</span>
                  </li>
                  <li>
                    <span class="m-list-title" for>Total</span>
                    <span class="m-list-desc">{{
                      formatCurrency(currency,data.header.total_klaim_cc)
                    }}</span>
                  </li>
                  <li>
                    <span class="m-list-title" for>Note</span>
                    <span class="m-list-desc">{{
                      data.header.catatan?data.header.catatan:'-'
                    }}</span>
                  </li>
                </ul>
              </div>
            </a-card>
            <a-collapse v-if="getScreen" class="margin-top" activeKey="1">
              <a-collapse-panel key="1">
                <h4 slot="header" class="margin-remove">Usage Details</h4>
                <a-list
                  itemLayout="vertical"
                  :dataSource="data.detail_invoice"
                  :pagination="pagination"
                >
                  <a-list-item slot="renderItem" slot-scope="item">
                    <a-list-item-meta>
                      <span slot="title">{{
                        item.deskripsi ? item.deskripsi : "Terima Uang Muka"
                      }}</span>
                      <div slot="description" class="margin-remove">
                        <span>{{
                          moment(item.tanggal).format(getDefaultDateFormat)
                        }}</span>
                        <div>
                          <span>{{ item.label }}</span>
                          <h4 class="margin-remove">
                            {{ formatCurrency(currency,item.nilai) }}
                          </h4>
                        </div>
                      </div>
                    </a-list-item-meta>
                  </a-list-item>
                </a-list>
              </a-collapse-panel>
            </a-collapse>
            <a-collapse v-if="!getScreen" class="margin-top" activeKey="1">
              <a-collapse-panel key="1">
                <h4 slot="header" class="margin-remove">Total Amount of Use</h4>
                <a-card :loading="pageLoading">
                  <ul class="m-list-wrapper">
                    <li>
                      <a-input-search
                        v-model="search"
                        style="width: 50%"
                        placeholder="Quick Search"
                        allowClear
                        :change="searching"
                      />
                    </li>
                  </ul>
                </a-card>
                <a-table
                  :columns="columns"
                  :dataSource="tableData"
                  :pagination="pagination"
                  size="small"
                  :scroll="{ x: 800 }"
                  bordered
                >
                  <template slot="type_ticket" slot-scope="text, item">
                    <span>{{item.type_ticket}}</span>
                  </template>
                  <template slot="user_booking" slot-scope="text, item">
                    <span>{{item.user_booking}}</span>
                  </template>
                  <template slot="no_booking" slot-scope="text, item">
                    <span>{{item.no_booking}}</span>
                  </template>
                  <span slot="deskripsi" slot-scope="item">
                    {{item.deskripsi}}
                  </span>
                  <template slot="no_sppd" slot-scope="item">
                    <b>{{ item.no_sppd ? 'SPPD : '+item.no_sppd : (item.no_pp ? 'PP : '+item.no_pp : (item.cost_center ? 'Cost Center : '+item.cost_center : '-')) }}</b>
                  </template>
                  <template slot="end_user" slot-scope="text, item">
                    <span>{{ item.end_user ? 'Employee : '+item.end_user+" - "+item.nama : (item.nama ? 'Foreigner : '+item.nama : '-') }}</span>
                  </template>
                  <span slot="kredit" slot-scope="kredit">
                    <CurrencyJustified
                      v-if="kredit.credit"
                      :currencyValue="'IDR'"
                      :valueNumber="kredit.credit"
                    />
                    <div v-else style="text-align: center; width: 100%">-</div>
                  </span>
                  <template slot="footer">
                    <a-row type="flex">
                      <a-col :span="5" :order="1" class="m-text-align left"
                        >Total Credit</a-col
                      >
                      <a-col
                        :span="5"
                        :order="2"
                        class="m-text-align left m-text-bold"
                        >{{ formatCurrency(currency,data.header.total_klaim_cc) }}</a-col
                      >
                    </a-row>
                  </template>
                  <template slot="document" slot-scope="index, item">
                    <a-button-group v-if="data.user_pembuat.tlc == getAuth.username" class="margin-top">
                      <a-button type="primary" icon="edit" @click="handleUploadDoc(item)" :loading="uploadDoc.loading2 && uploadDoc.loading2key==item.id_dtl"></a-button>
                      <a-button type="default" icon="eye" @click="viewlampiranDoc(item.lampiran_path)" v-if="item.lampiran">View</a-button>
                      <a-button type="default" disabled v-else>No File</a-button>
                    </a-button-group>
                    <a v-else-if="item.lampiran" @click="viewlampiranDoc(item.lampiran_path)" class="margin-top">
                      View Document
                    </a>
                    <div v-else class="margin-top">
                      :: No File Uploaded ::
                    </div>
                  </template>
                </a-table>
              </a-collapse-panel>
            </a-collapse>
            <a-card
              class="margin-top"
              :loading="pageLoading"
              v-if="
                data.jenis.toLowerCase() !== 'manifest' &&
                data.jenis.toLowerCase() !== 'transfer'
              "
            >
            <div slot="title">Manifest Actions
              &nbsp;<i v-if="data.jenis=='Transfer' && !data.status_transfer" style="color:red!important">(Funding has not been set)</i>
            </div>
            <!-- <div slot="extra">
                <h5 class="m-text-align right margin-remove">
                  remaining balance
                </h5>
                <a-tag color="green" class="m-text-align right margin-remove">{{
                  formatCurrency(currency,data.sisa_tf)
                }}</a-tag>
              </div> -->
            <template>
              <a-form :form="form">
                <a-form-item label="Note">
                  <a-textarea
                    placeholder="Write the note here ... "
                    :rows="4"
                    v-decorator="['catatan']"
                  />
                </a-form-item>
                <a-form-item label="Aksi">
                  <a-select
                    showSearch
                    v-decorator="[
                      'aksi',
                      {
                        rules: [{ required: true }],
                        defaultValue: data.aksi[0].aksi,
                      },
                    ]"
                  >
                    <a-select-option v-for="item in data.aksi" :key="item.aksi">{{
                      item.aksi
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-form>
              <template class="ant-card-actions" slot="actions">
                <a-button
                  :loading="saveLoading"
                  @click="handleAction"
                  block
                  type="primary"
                  html-type="submit"
                  >Save</a-button
                >
              </template>
            </template>
            </a-card>
            <!-- <a-card
              class="margin-top"
              :loading="pageLoading"
              v-if="data.jenis.toLowerCase() === 'transfer'"
            >
              <div slot="title">Manifest Actions
                &nbsp;<i v-if="data.jenis=='Transfer' && !data.status_transfer" style="color:red!important">(Funding has not been set)</i>
              </div>
              <div slot="extra">
                  <h5 class="m-text-align right margin-remove">
                    remaining balance
                  </h5>
                  <a-tag color="green" class="m-text-align right margin-remove">{{
                    formatCurrency(currency,data.sisa_tf)
                  }}</a-tag>
                </div>
              <template v-if="!(data.jenis=='Transfer' && !data.status_transfer)">
                <a-form :form="form">
                  <a-form-item label="Aksi">
                    <a-select
                      @change="handleAksi"
                      showSearch
                      v-decorator="[
                        'status',
                        {
                          rules: [{ required: true }],
                          initialValue: data.aksi[0].aksi,
                        },
                      ]"
                    >
                      <a-select-option v-for="item in data.aksi" :key="item.aksi">{{
                        item.aksi
                      }}</a-select-option>
                    </a-select>
                  </a-form-item>
                  <a-form-item v-if="!isRevised" label="Transfer Date">
                    <a-date-picker
                      placeholder="Select Date"
                      :format="getDefaultDateFormat"
                      v-decorator="['tgl_trf', { rules: [{ required: true }] }]"
                    />
                  </a-form-item>
                  <a-form-item label="Evidence of transfer" v-if="!isRevised">
                    <a-upload
                      accept="image/*"
                      :showUploadList="true"
                      :remove="removeFileList"
                      :fileList="push"
                      listType="picture"
                      :beforeUpload="beforeUpload"
                      v-decorator="[
                        'upload',
                        { rules: [{ required: true }] },
                        { valuePropName: 'push' },
                      ]"
                    >
                      <a-button>
                        <a-icon type="upload" />&nbsp;Select your file
                      </a-button>
                    </a-upload>
                  </a-form-item>
                  <a-form-item label="Transfer Value" v-if="!isRevised">
                    <a-input-number
                      :disabled="disabled"
                      :max="data.sisa_tf"
                      @keydown="onlyNumber"
                      class="m-width-full m-text-align right"
                      :formatter="
                        (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                      "
                      :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                      v-decorator="[
                        'value_transferan',
                        { rules: [{ required: true }], initialValue: data.sisa_tf },
                      ]"
  
                    />
                  </a-form-item>
                  <a-checkbox
                    class="margin-bottom"
                    @change="handleCheckData"
                    :checked="checkTransferValue"
                    v-if="!isRevised"
                    >The transferred value matches of the remaining
                    balance</a-checkbox
                  >
                  <a-form-item label="Note">
                    <a-textarea
                      placeholder="Write the note here ... "
                      :rows="4"
                      v-decorator="['remark']"
                    />
                  </a-form-item>
                </a-form>
                <template class="ant-card-actions" slot="actions">
                  <a-button
                    :loading="saveLoading"
                    @click="handleAction"
                    block
                    type="primary"
                    html-type="submit"
                    >Save</a-button
                  >
                </template>
              </template>
            </a-card> -->
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">

            <a-collapse  activeKey="1">
              <a-collapse-panel key="1">
                <div
                  class="m-display-flex space-between align-middle"
                  slot="header"
                >
                  <h4 class="margin-remove">Status</h4>
                  <div>
                    <Status :status="data.last_status=='Canceled' ? 'Cancelled' : data.last_status" />
                    <a-tooltip class="m-tooltip-inner" placement="bottomLeft">
                      <template slot="title">
                        <span>History</span>
                      </template>
                      <a-button
                        @click="historyToggle"
                        type="default"
                        size="small"
                        class="margin-right-small"
                      ><a-icon type="clock-circle" />
                      </a-button>
                    </a-tooltip>
                  </div>
                </div>
                <a-timeline class="m-timeline">
                  <a-timeline-item color="green">
                    <div class="m-timeline-title">
                      Pembuat - {{ data.user_pembuat.tlc }}
                    </div>
                    <div class="m-timeline-body">
                      <h4 class="margin-remove">
                        {{
                          moment(data.header.tanggal_buat).format(
                            'DD-MM-YYYY HH:mm:ss'
                          )
                        }}
                      </h4>
                    </div>
                    <div class="m-timeline-footer">
                      <a-tag color="green">{{ data.user_pembuat.status }}</a-tag>
                    </div>
                  </a-timeline-item>
                  <a-timeline-item
                    v-for="workflow in data.status"
                    :key="workflow.step_no"
                    :color="
                      workflow.status === 'On Process' ||
                      workflow.status === 'Delivered'
                        ? 'red'
                        : workflow.status === 'Waiting'
                        ? 'grey'
                        : 'green'
                    "
                  >
                    <div class="m-timeline-title">
                      {{ workflow.actor }}
                      {{ workflow.tlc ? " - " + workflow.tlc : "" }}
                    </div>
                    <div class="m-timeline-body">
                      <h4
                        class="margin-remove"
                        v-if="workflow.tanggal_aksi !== null"
                      >
                        {{ moment(workflow.tanggal_aksi).format('DD-MM-YYYY HH:mm:ss') }}
                      </h4>
                      <span class="m-text-small" v-if="workflow.remark">{{
                        workflow.remark
                      }}</span>
                      <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                    </div>
                    <div class="m-timeline-footer">
                      <Status :status="workflow.status" />
                    </div>
                  </a-timeline-item>
                </a-timeline>
              </a-collapse-panel>
            </a-collapse>
            <!-- <a-collapse class="margin-top" activeKey="1">
              <a-collapse-panel key="1">
                <div
                  class="m-display-flex space-between align-middle"
                  slot="header"
                >
                  <h4 class="margin-remove">Related Document</h4>
                </div>
  
                <a-list
                  itemLayout="horizontal"
                  :dataSource="data.dokumen_terkait"
                >
                  <Empty
                    v-if="
                      data.dokumen_terkait
                        ? data.dokumen_terkait.length <= 0
                        : data.dokumen_terkait
                    "
                  />
                  <a-list-item slot="renderItem" slot-scope="item">
                    <a-list-item-meta>
                      <div
                        slot="title"
                        class="m-display-flex space-between align-middle"
                      >
                        <a @click="handleView(item)"
                          >{{ item.header }} | {{ item.tlc }}</a
                        >
                        <Status
                          :class="!getScreen ? 'margin-remove' : ''"
                          :status="item.status"
                        />
                      </div>
                      <div
                        slot="title"
                        class="m-display-flex space-between align-middle"
                        v-if="item.no_manifest"
                      >
                        <span>{{ item.no_manifest }}</span>
                      </div>
                      <div slot="description" v-if="item.tgl_mulai_dinas">
                        <span
                          >{{
                            moment(
                              item.tgl_mulai_dinas,
                              getStandartFormatDate
                            ).format(getDefaultDateFormat)
                          }}
                          -
                          {{
                            moment(
                              item.tgl_selesai_dinas,
                              getStandartFormatDate
                            ).format(getDefaultDateFormat)
                          }}</span
                        >
                      </div>
                      <div slot="description">
                        <div class="m-width-full">
                          <a-tooltip
                            class="ant-tooltip-inner"
                            placement="top"
                            :title="
                              item.deskripsi
                                ? item.deskripsi
                                : 'Tidak ada deskripsi'
                            "
                          >
                            <span class="ant-description-ellipses">{{
                              item.deskripsi
                                ? item.deskripsi
                                : "Tidak ada deskripsi"
                            }}</span>
                          </a-tooltip>
                        </div>
                      </div>
                      <div
                        slot="title"
                        v-if="item.value_transaksi && item.rest_api !== 'sppds'"
                      >
                        <span class="m-timeline-title">{{
                          formatCurrency(currency,item.value_transaksi)
                        }}</span>
                      </div>
                    </a-list-item-meta>
                  </a-list-item>
                </a-list>
              </a-collapse-panel>
            </a-collapse> -->
          </a-col>
        </a-row>
      </div>
      <a-modal v-model="visibleHistory" @ok="historyToggle" :footer="null">
        <span slot="title"> <a-icon type="clock-circle-o" />&nbsp;History Status </span>
  
        <ul class="m-list-wrapper bordered">
          <li v-for="history in data.history" :key="history.id_notifikasi">
            <div v-if="history.aksi === '1' || history.aksi === '3'">
              <div class="m-display-flex space-between">
                <h3 class="margin-remove m-list-title">
                  {{ history.as_from }}
                  {{ history.tlc_from ? "|" + history.tlc_from : "" }}
                </h3>
                <Status :status="history.deskripsi" />
              </div>
              <span class="m-list-desc">{{ history.tgl_notif }}</span>
            </div>
            <div v-else-if="history.aksi === '2' || history.aksi === '4'">
              <div class="m-display-flex space-between">
                <h3
                  class="margin-remove m-list-title"
                  v-if="history.aksi === '4' && history.deskripsi === 'Edited'"
                >
                  {{ history.as_from }}
                  {{ history.tlc_from ? "|" + history.tlc_from : "" }}
                </h3>
                <h3 class="margin-remove m-list-title" v-else>
                  {{ history.as_to }}
                  {{ history.tlc_to ? "|" + history.tlc_to : "" }}
                </h3>
                <Status :status="history.deskripsi" />
              </div>
              <span class="m-list-desc">{{ history.tgl_notif }}</span>
            </div>
          </li>
        </ul>
      </a-modal>
      <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
        <div class="margin-top"></div>
        <a-divider class="margin-small" />
        <img alt="example" style="width: 100%" :src="previewImage" />
      </a-modal>
  
      <a-modal v-model="visibleUploadDoc" @ok="historyToggle" :footer="null">
        <span slot="title"> <a-icon type="upload" />&nbsp;Upload Transaction Document </span>
        <a-spin tip="Your document is being processed, do not leave this page!" :spinning="uploadDoc.loading"
        >
          <a-row :gutter="8">
            <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
              <b>Tanggal</b>
            </a-col><a-col :xs="{ span: 24 }" :lg="{ span: 1 }">:</a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 15 }">
              <a-input v-model="uploadDoc.tanggal" disabled></a-input>
            </a-col>
          </a-row>
          <a-row :gutter="8" class="margin-top">
            <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
                <b>Description</b>
              </a-col>
              <a-col :xs="{ span: 24 }" :lg="{ span: 1 }">:</a-col>
              <a-col :xs="{ span: 24 }" :lg="{ span: 15 }">
                <a-textarea v-model="uploadDoc.deskripsi" disabled></a-textarea>
              </a-col>
          </a-row>
          <a-row :gutter="8" class="margin-top">
            <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
                <b>Transaction Document</b>
              </a-col>
              <a-col :xs="{ span: 24 }" :lg="{ span: 1 }">:</a-col>
              <a-col :xs="{ span: 24 }" :lg="{ span: 15 }">
                <a-upload
                  :showUploadList="true"
                  :fileList="uploadDoc.doctransfiles"
                  :beforeUpload="beforedoctransUpload"
                  v-model="uploadDoc.file"
                  :disabled="uploadDoc.loading"
                >
                <!-- :remove="handledoctransRemove" -->
                  <a-button>
                    <a-icon type="upload" />&nbsp;Select File
                  </a-button>
                </a-upload>
              </a-col>
          </a-row>
        </a-spin> 
      </a-modal>
    </div>
  </template>
  
  <script>
  import axios from "axios";
  import { mapGetters } from "vuex";
  import Status from "@/components/Status.vue";
  import CurrencyFormat from "@/mixins/CurrencyFormat";
  import HandleRoute from "@/mixins/HandleRoute";
  import GlobalMethod from "@/mixins/GlobalMethod.js";
  import moment from "moment";
  
  export default {
    name: "ManifestKlaimCCTiket",
    components: { Status },
    props: ["id", "tlc", "user_pembuat"],
    mixins: [CurrencyFormat, HandleRoute, GlobalMethod],
    data() {
      return {
        currency:"",
        previewVisible: false,
        previewImage: "",
        visibleHistory: false,
        pageLoading: true,
        saveLoading: false,
        disabled: true,
        data: {
          no_pp: '',
          no_transaksi: '',
          tanggal_buat: '',
  
          user_pelapor: '',
          total_klaim_cc: '',
          kode_project: '',
        },
        push: [],
        isRevised: false,
        pagination: {
          onChange: (page) => {},
          pageSize: 5,
          size: "small",
        },
        tableData: [],
        tableDataTemp: [],
        search: "",
        printLoad: {
          manifest: false,
          manifestkomisi: false,
          cancel: false,
          manifestfiktif: false,
          manifestWtNote: false,
        },
        checkTransferValue: true,
        visibleUploadDoc: false,
        uploadDoc: {
          file: null,
          doctransfiles: null,
          id_dtl_trans: null,
          tanggal: null,
          deskripsi: null,
          loading: false,
          loading2: false,
          loading2key: "",
        },
      };
    },
    beforeCreate() {
      this.form = this.$form.createForm(this);
    },
    beforeDestroy() {
      Event.$off("confirmMessageReturn", this.handleActionProcess);
      Event.$off("handleCancel", this.canceltrans);
    },
    created() {
      this.fetchManifest();
  
      if (!this.getScreen) {
        this.getDetailPemakaianWeb();
      }
    },
    watch: {
      id() {
        if (this.id) {
          this.fetchManifest();
          this.form = this.$form.createForm(this);
          this.push = [];
          this.checkTransferValue = true;
          this.disabled = true;
          this.search = "";
          this.isRevised = false;
        }
  
        if (!this.getScreen) {
          this.getDetailPemakaianWeb();
        }
      },
    },
    computed: {
      ...mapGetters([
        "getScreen",
        "getAuth",
        "getDefaultDateFormat",
        "getIsSpecialMenu",
        "getDateTimeFormat",
        "getDateTimeStandartFormat",
      ]),
      columns() {
        let { sortedInfo, filteredInfo } = this;
        sortedInfo = sortedInfo || {};
        filteredInfo = filteredInfo || {};
  
        const kolom = [
          {
            title: "No",
            dataIndex: "no",
            key: "no",
            width: 59,
            sorter: (a, b) => a.no - b.no,
          },
          {
            title: "Date",
            dataIndex: "expense_date",
            width: 100,
            key: "expense_date",
            sorter: (a, b) =>
              new Date(
                moment(a.expense_date, this.getDefaultDateFormat).format(
                  this.getStandartFormatDate
                )
              ) -
              new Date(
                moment(b.expense_date, this.getDefaultDateFormat).format(
                  this.getStandartFormatDate
                )
              ),
          },
          {
            title: "Ticket Type",
            key: "type_ticket",
            width: 150,
            scopedSlots: { customRender: "type_ticket" },
            sorter: (a, b) => a.type_ticket.localeCompare(b.type_ticket),
          },
          {
            title: "User Booking",
            key: "user_booking",
            width: 150,
            scopedSlots: { customRender: "user_booking" },
            sorter: (a, b) => a.user_booking.localeCompare(b.user_booking),
          },
          {
            title: "No Booking",
            key: "no_booking",
            width: 150,
            scopedSlots: { customRender: "no_booking" },
            sorter: (a, b) => a.no_booking.localeCompare(b.no_booking),
          },
          {
            title: "Description",
            key: "deskripsi",
            width: 200,
            sorter: (a, b) => a.deskripsi.length - b.deskripsi.length,
            scopedSlots: { customRender: "deskripsi" },
          },
          {
            title: "Document",
            key: "document",
            scopedSlots: { customRender: "document" },
            width: 150,
            align: "center"
          },
          {
            title: "Budget Type",
            key: "no_sppd",
            width: 250,
            scopedSlots: { customRender: "no_sppd" },
            sorter: (a, b) => a.no_sppd ? a.no_sppd.localeCompare(b.no_sppd) : 
              (a.no_pp ? a.no_pp.localeCompare(b.no_pp) : (a.cost_center ? a.cost_center.localeCompare(b.cost_center) : false)),
          },
          {
            title: "End User Type",
            key: "end_user",
            width: 250,
            scopedSlots: { customRender: "end_user" },
            sorter: (a, b) => a.end_user.localeCompare(b.end_user),
          },
          {
            title: "Credit",
            key: "credit",
            align: "right",
            width: 170,
            scopedSlots: { customRender: "kredit" },
            sorter: (a, b) => a.credit.length - b.credit.length,
          },
        ];
        return kolom;
      },
  
      searching() {
        if (this.search) {
          this.tableData = this.tableDataTemp;
          this.tableData = this.tableData.filter(
            (obj) =>
              obj.deskripsi.toLowerCase().indexOf(this.search.toLowerCase()) >=
                0 ||
              moment(obj.tanggal, "DD-MM-YYYY")
                .format("DD-MM-YYYY")
                .toString()
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) >= 0 ||
              (obj.type_ticket && obj.type_ticket.toLowerCase().indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.user_booking && obj.user_booking.toLowerCase().indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.no_booking && obj.no_booking.toLowerCase().indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.no_sppd && obj.no_sppd.toLowerCase().indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.no_pp && obj.no_pp.toLowerCase().indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.end_user && obj.end_user.toLowerCase().indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.end_user_nm && obj.end_user_nm.toLowerCase().indexOf(this.search.toLowerCase()) >= 0)
          );
        }
  
        if (!this.search) {
          this.tableData = this.tableDataTemp;
        }
  
        return this.tableData;
      },
    },
    methods: {
      moment,
      fetchManifest() {
        axios({
          method: "get",
          url: this.$serviceUrl + "lap_tiket_pd",
          params: {
            id_laporan: this.id,
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
        }).then((response) => {
            this.id = response.data.invoice[0].id_laporan;
            this.currency = response.data.invoice[0].currency;
            this.data = {
              status_transfer: response.data.value_transfer,
              header: {
                no_pp: response.data.invoice[0].no_cc,
                no_transaksi: response.data.invoice[0].no_transaksi,
                tanggal_buat: response.data.invoice[0].report_date,
  
                user_pelapor: response.data.invoice[0].nama,
                total_klaim_cc: response.data.invoice[0].total || 0,
                kode_project: response.data.invoice[0].kode_project,
                catatan: response.data.invoice[0].note,
                user_cc: response.data.invoice[0].user_cc
              },
              jenis: response.data.jenis,
              last_status: response.data.invoice[0].status,
              user_pembuat: {
                tlc: response.data.invoice[0].tlc,
                tanggal: response.data.invoice[0].tgl_buat,
  
                status: "Created",
              },
              sisa_tf: response.data.sisa_tf,
              aksi: response.data.aksi,
              bukti_transfer: response.data.detail_bukti_transfer,
              detail_invoice: response.data.dtl_invoice,
              dokumen_terkait: response.data.dokumen_terkait,
              status: response.data.status_app,
              history: response.data.notifikasi,
              iskomisi: response.data.iskomisi
            };
  
            if (!this.getScreen) {
              let dataPemakaian = response.data.dtl_invoice;
  
              response.data.dtl_invoice.forEach((value, index) => {
                dataPemakaian[index]["kredit"] = {
                  curr: 'IDR',
                  val: Number(value.credit),
                };
                dataPemakaian[index]["no"] = index + 1;
                dataPemakaian[index]["key"] = index + 1;
                dataPemakaian[index]["tanggal"] = moment(value.tanggal).format(
                  this.getDefaultDateFormat
                );
                dataPemakaian[index]["end_user_nm"] = value.end_user_nm;
                dataPemakaian[index]["deskripsi"] = value.description;
                dataPemakaian[index]["end_user_nm"] = value.end_user_nm;
                dataPemakaian[index]["no_sppd"] = value.no_sppd;
              });
  
              this.tableData = dataPemakaian;
              this.tableDataTemp = dataPemakaian;
            }
  
            this.pageLoading = false;
          })
          .catch((err) => {
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error", responses);
            this.pageLoading = false;
            // this.$router.go(-1);
          });
      },
      historyToggle(e) {
        e.stopPropagation();
        this.visibleHistory = !this.visibleHistory;
      },
      handlePrint(item) {
        this.printLoad.manifest = true;
        axios({
          method: "get",
          url: this.$serviceUrl + "lap_tiket_pd/cetak",
          responseType: "blob",
          params: {
            id_laporan: this.id
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            let blob = new Blob([response.data], { type: "application/pdf" }),
              url = window.URL.createObjectURL(blob);
            window.open(url, "_blank");
            this.pageLoading = false;
            this.printLoad.manifest = false;
          })
          .catch((err) => {
            if (err.response.status === 404) {
              this.displayMessage("404");
            }
            this.pageLoading = false;
            this.printLoad.manifest = false;
            this.$router.go(-1);
          });
      },
      handleAction() {
        this.form.validateFields((err, values) => {
          if (err) {
            this.displayMessage("form-warning");
            return;
          }
          this.confirmMessage("confirm-save");
        });
      },
      handleActionProcess() {
        this.saveLoading = true;
        if (this.data.jenis.toLowerCase() === "transfer") {
          this.form.validateFields((err, values) => {
            if (err) {
              this.displayMessage("form-warning");
              return;
            }
  
            let post = new FormData();
            post.append("id_laporan", this.id);
            post.append("tlc", this.getAuth.username);
            post.append("status", values.status);
            post.append("remark", values.remark);
  
            axios({
              method: "post",
              url: this.$serviceUrl + "lap_tiket_pd/approval",
              processData: false,
              data: post,
              auth: {
                username: this.getAuth.username,
                password: this.getAuth.password,
              },
              headers: {
                "Content-Type": "application/json",
                "X-API-KEY": this.getAuth.apikey,
              },
            })
              .then((response) => {
                this.displayMessage("success");
                this.saveLoading = false;
                this.$router.go();
              })
              .catch((err) => {
                this.saveLoading = false;
                let responses = Object.assign({}, err.response.data);
                this.displayMessageValue("error", responses);
              });
          });
        } else {
          this.form.validateFields((err, values) => {
            if (err) {
              this.displayMessage("choose-action");
              return;
            }
  
            axios({
              method: "post",
              url: this.$serviceUrl + "lap_tiket_pd/approval ",
              processData: false,
              data: {
                id_laporan: this.id,
                tlc: this.getAuth.username,
                status: values.aksi,
                remark: values.catatan ? values.catatan : "",
              },
              auth: {
                username: this.getAuth.username,
                password: this.getAuth.password,
              },
              headers: {
                "Content-Type": "application/json",
                "X-API-KEY": this.getAuth.apikey,
              },
            })
              .then((response) => {
                this.displayMessage("success");
                this.saveLoading = false;
                this.$router.go();
              })
              .catch((err) => {
                this.saveLoading = false;
                let responses = Object.assign({}, err.response.data);
                this.displayMessageValue("error", responses);
              });
          });
        }
      },
      handleCheckData(e) {
        if (e.target.checked) {
          this.disabled = true;
          this.checkTransferValue = true;
          this.form.setFieldsValue({
            value_transferan: this.data.sisa_tf,
          });
        } else {
          this.disabled = false;
          this.checkTransferValue = false;
          this.form.setFieldsValue({
            value_transferan: 0,
          });
        }
      },
      beforeUpload(file) {
        const FileSize = file.size / 1024 / 1024;
        if (FileSize > 2) {
          this.displayMessage("large-file-2mb");
        } else {
          this.push = [file];
          return false;
        }
      },
      removeFileList() {
        this.push = [];
      },
      handleCancel() {
        this.previewVisible = false;
      },
      handleViewBt(file) {
        console.log(file);
        if (file.url.substr(file.url.length - 3) === "pdf") {
          window.open(this.$serviceUrl + file.url, "_blank");
        } else {
          this.previewImage = this.$serviceUrl + file.url;
          this.previewVisible = true;
        }
      },
      handleAksi(e) {
        if (e == "Revised") {
          this.isRevised = true;
          this.disabled = false;
          this.push = [];
        } else {
          this.disabled = true;
          this.isRevised = false;
        }
      },
  
      getDetailPemakaianWeb() {
        // axios({
        //     method: "get",
        //     url: this.$serviceUrl + "klaim_biaya_pd/web_detil_pemakaian",
        //     params: {
        //         id: this.id
        //     },
        //     auth: {
        //         username: this.getAuth.username,
        //         password: this.getAuth.password
        //     },
        //     headers: {
        //         "X-API-KEY": this.getAuth.apikey
        //     }
        // })
        //     .then(response => {
        //         let dataPemakaian = response.data.detail_pemakaian;
        //         response.data.detail_pemakaian.forEach((value,index)=>{
        //             if(value.debit !== '-'){
        //                 dataPemakaian[index]['debit'] = this.formatCurrency(value.currency,value.debit);
        //             }
        //             if(value.kredit !== '-'){
        //                 dataPemakaian[index]['kredit'] = this.formatCurrency(value.currency,value.kredit);
        //             }
        //             dataPemakaian[index]['sisa'] = this.formatCurrency(value.currency,value.sisa);
        //             dataPemakaian[index]['tanggal'] = moment(value.tanggal).format(this.getDefaultDateFormat);
        //         })
        //         this.tableData =  dataPemakaian;
        //         this.tableDataTemp =  dataPemakaian;
        //     })
        //     .catch(err => {
        //         if (err.response.status === 404) {
        //             this.$notification.error({
        //                 message: "Oops..",
        //                 description: "Alien sedang menyerang 😆"
        //             });
        //         }
        //         this.pageLoading = false;
        //         this.$router.go(-1);
        //     });
      },
      handlecanceltrans() {
        this.confirmMessageValue("confirm-cancel", null, null);
      },
      canceltrans() {
        this.printLoad.cancel = true;

        let data = new FormData();
        data.append("jenis_trans", "klaim_cc_tiket");
        data.append("id_manifest", this.id);
        
        this.asyncAxiosPost("main/cancel_transaction", "formdata", this.getAuth, data)
        .then((response) => {
          this.printLoad.cancel = false;
          this.displayMessageValue("successCancel", response.message);
          this.$router.go(-1);
        }).catch((error) => {
          this.printLoad.cancel = false;
          this.displayMessageValue("error", error.message);
        });

        // this.$store.dispatch("cancelTransaction", { auth: this.getAuth, data: data })
        // .then((response) => {
        //   this.printLoad.cancel = false;
        //   this.displayMessageValue("successCancel", response.data.message);
        //   this.$router.go();
        // })
        // .catch((error) => {
        //   this.printLoad.cancel = false;
        //   this.displayMessageValue("error", error.message);
        // });
      },
      handleEdit() {
        this.$router.push({
          name: "revise_klaim_tiket",
          params: { id: this.id, type: "revised" },
        });
      },
      viewlampiranDoc(url) {
        window.open(this.$serviceUrl + url, "_blank");
      },
      handleUploadDoc(item) {
        console.log(item);
        
        this.uploadDoc.tanggal = item.tanggal;
        this.uploadDoc.deskripsi = item.deskripsi;
        this.uploadDoc.id_dtl_trans = item.id;
        this.uploadDoc.id_laporan = item.id_laporan;
        this.uploadDoc.doctransfiles = [];
  
        if (item.lampiran) {
          this.uploadDoc.loading2 = true;
          this.uploadDoc.loading2key = item.id_dtl;
          this.asyncAxiosGet("main/base_64", this.getAuth, {
            path: item.lampiran_path,
          })
            .then((response) => {
              let typefile = this.fileTypeFromUrl(item.lampiran);
              let file = this.dataURLtoFile(
                typefile + response.file_document_tax,
                item.lampiran
              );
              file.uid = "vc-upload-1-1";
              file.status = "done";
              file.url = this.$serviceUrl + item.lampiran_path;
              this.uploadDoc.doctransfiles = [];
              this.uploadDoc.doctransfiles.push(file);
  
              this.uploadDoc.loading2 = false;
              this.uploadDoc.loading2key = "";
              this.visibleUploadDoc = true;
            })
            .catch((err) => {
              this.uploadDoc.loading2 = false;
              this.uploadDoc.loading2key = "";
              console.log(err);
              let responses = Object.assign({}, err.response.data);
              this.displayMessageValue("error-other", responses.message);
            });
        } else {
          this.visibleUploadDoc = true;
        }
      },
      beforedoctransUpload(file) {
        const FileSize = file.size / 1024 / 1024;
        if (FileSize > 5) {
          this.displayMessage("large-file-5mb");
        } else {
          console.log(this.uploadDoc);
          
          let data = new FormData();
          data.append("id", this.uploadDoc.id_dtl_trans);
          data.append("id_laporan", this.uploadDoc.id_laporan);
          data.append("file_upload", file);
  
          this.uploadDoc.loading = true;
          this.asyncAxiosPost("lap_tiket_pd/dtl_lampiran", "formdata", this.getAuth, data)
            .then((response) => {
              if (response.status && response.status == true) {
                this.displayMessageValue("success-other", response.message);
                this.fetchManifest()

              } else {
                let responses = Object.assign({}, response);
                this.displayMessageValue("error-other", responses);
              }
              this.uploadDoc.loading = false;
              // this.getDetailPemakaianWeb();
              this.data.detail_invoice.forEach(element => {
                if(element.id_dtl==this.uploadDoc.id_dtl_trans){
                  element.lampiran_path = response.data[0].lampiran_path
                  element.lampiran = response.data[0].lampiran
                }
              });
              
              this.visibleUploadDoc = false;
            })
            .catch((err) => {
              console.log(err);
              this.uploadDoc.loading = false;
              if (err.response && err.response.data) {
                this.$notification.error({
                  message: "Error Message",
                  description: err.response.data.message,
                });
              } else {
                let responses = Object.assign({}, err.response);
                this.displayMessageValue("error", responses);
              }
            });
          this.uploadDoc.doctransfiles = [file];
          return false;
        }
      },
      handledoctransRemove() {
        this.uploadDoc.doctransfiles = [];
      },
      testRoute(){
        this.$router.push({
          name: 'klaim_cc_tiket_pu',
          params: { id: this.id }
        })
      }
    },
    mounted() {
      Event.$on("confirmMessageReturn", this.handleActionProcess);
      Event.$on("handleCancel", this.canceltrans);
    },
  };
  </script>
  
  <style scoped lang="less">
  .m-image-icon {
    width: 50px;
  }
  </style>